module.exports = __webpack_public_path__ + "static/media/role.ecacd4ab.svg";